import React from 'react';
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

function RequestCheckAlert({ isOpen, onClose, heading  }) {
    function closeModal() {
        onClose();
      }
  return (
    <Transition appear show={true} as={Fragment}>
      <Dialog as="div" className="relative z-[999999]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center ">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-md bg-[#171538] p-4 text-left align-middle shadow-xl transition-all relative">
                
              
               

                {/* Success Message */}
                <Dialog.Title as="h3" className="text-[17px] font-medium leading-6 text-white text-center mt-5">
                  {heading}
                </Dialog.Title>
                
                {/* OK Button */}
                <div className="flex justify-center mt-7">
                  <button
                    onClick={onClose}
                    className="bg-[#5550d2] text-white px-5 py-2 rounded"
                  >
                    OK
                  </button>
                </div>
                <div className="absolute top-2 right-2 ">
                      <button
                        type="button"
                        className="outline-none rounded-full  hover:bg-[#342f4f]"
                        onClick={closeModal}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1"
                          stroke="white"
                          className="w-6 h-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default RequestCheckAlert;
